
<div class="prediction-selector-container">
<p-treeSelect
	[(ngModel)]="selectedNodeKey"
	[options]="treeData()"
	[placeholder]="placeholder"
	[filter]="true"
	[appendTo]="'body'"
	[disabled]="isDisabled || isLoading"
	[metaKeySelection]="false"
	[filterInputAutoFocus]="false"
	[scrollHeight]="'240px'"
	(onNodeSelect)="onNodeSelect($event)">
</p-treeSelect>
</div>  
